import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import FormBuilder from './FormBuilder.page';

export const mapStateToProps = state => ({
  deviceHeight: state.general.deviceHeight,
  formValue: getFormValues('allBiller')(state),
});

export default reduxForm({
  form: 'allBiller',
})(connect(mapStateToProps)(FormBuilder));
